import React from 'react';
import { Grid, GridItem, Chip } from '@drone-js/core';
import { connect } from 'react-redux';
import { EarnBurnToggleProps, mapStateToProps } from 'component/common/EarnBurnToggle/EarnBurnToggle.selectors';

const EarnBurnToggle: React.FC<EarnBurnToggleProps> = React.memo((props) => {
    const { isEarn, onToggleChange } = props;

    return (
        <div data-testid="earn-burn-toggle-container">
            <Grid spacing="12" fluid={true}>
                <GridItem lg={12} sm={6}>
                    <Chip
                        label={props.cms[285689]}
                        caption={props.cms[285690]}
                        minWidth="100%"
                        onClick={() => !isEarn && onToggleChange(true)}
                        selection={isEarn ? 'selected' : 'unselected'}
                        data-testid="earn-toggle-chip"
                    />
                </GridItem>
                <GridItem lg={12} sm={6}>
                    <Chip
                        label={props.cms[285691]}
                        caption={props.cms[285692]}
                        minWidth="100%"
                        onClick={() => isEarn && onToggleChange(false)}
                        selection={!isEarn ? 'selected' : 'unselected'}
                        data-testid="burn-toggle-chip"
                    />
                </GridItem>
            </Grid>
        </div>
    );
});

EarnBurnToggle.displayName = 'EarnBurnToggle';

export default connect(mapStateToProps)(EarnBurnToggle);
